// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingDeprecatedV2_container__1aBnA","wrapper":"SettingDeprecatedV2_wrapper__12e9h"};